import { CellEventFormatterProps } from '../../utils'
import React from 'react'
import styled from 'styled-components/macro'

export const NoteUpdateEvent = ({ event }: CellEventFormatterProps) => {
  const getNoteType = () => {
    switch (event.content_type.model) {
      case 'companynote':
        return 'Company Note'
      case 'contactnote':
        return 'Contact Note'
      default:
        return 'Note'
    }
  }

  return (
    <span>
      edited a <GreenBold>{getNoteType()}</GreenBold>
    </span>
  )
}

export const GreenBold = styled.b`
  color: #087443;
`
